import {Aggregation, AggregationOption, ProductAttributeFilterInput} from '@/__generated__/__types__';
import React, {forwardRef} from 'react';
import FilterList from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/components/filter-list';
import {getPriceRangeByAggregationOption} from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/helper/attributes';
import MultiRangeSlider, {
    MultiRangeSliderMethods,
} from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/components/multi-range-slider';
import {FilterByPriceInput} from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter-toolbar.type';

interface FilterAggregationItemProps {
    aggregation: Aggregation;
    query: Record<string, any>;
    filter: ProductAttributeFilterInput;
    onFilterByPrice: (value: FilterByPriceInput) => void;
    onQueryChange: (attribute_code: string, buttonValue: string, isSelected: boolean) => void;
    openBrandFiltering: () => void;
}

const FilterAggregationItem = forwardRef<MultiRangeSliderMethods, FilterAggregationItemProps>(
    ({aggregation, filter, query, onFilterByPrice, onQueryChange, openBrandFiltering}, ref) => {
        if (!aggregation.attribute_code) return null;

        if (aggregation.attribute_code === 'price') {
            return (
                <div key={aggregation.attribute_code} className="mx-4 mb-9">
                    <p className="text-sm font-bold text-KPZ_text_1st">{aggregation.label}</p>
                    <div className="px-3 pt-4">
                        <MultiRangeSlider
                            ref={ref}
                            min={getPriceRangeByAggregationOption(
                                (aggregation.options ?? []) as AggregationOption[],
                                'min',
                            )}
                            max={getPriceRangeByAggregationOption(
                                (aggregation.options ?? []) as AggregationOption[],
                                'max',
                            )}
                            default={{
                                minDefault: +filter?.price?.from!,
                                maxDefault: +filter?.price?.to!,
                            }}
                            step={10000}
                            onChange={onFilterByPrice}
                        />
                    </div>
                </div>
            );
        }

        if (aggregation.attribute_code === 'price') {
            return (
                <div key={aggregation.attribute_code} className="mx-4 mb-9">
                    <p className="text-sm font-bold text-KPZ_text_1st">{aggregation.label}</p>
                    <div className="px-3 pt-4">
                        <MultiRangeSlider
                            min={getPriceRangeByAggregationOption(
                                (aggregation.options ?? []) as AggregationOption[],
                                'min',
                            )}
                            max={getPriceRangeByAggregationOption(
                                (aggregation.options ?? []) as AggregationOption[],
                                'max',
                            )}
                            default={{
                                minDefault: +filter?.price?.from!,
                                maxDefault: +filter?.price?.to!,
                            }}
                            step={10000}
                            onChange={onFilterByPrice}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div key={aggregation.attribute_code}>
                <hr className="mx-4"></hr>
                <div className="mx-4 pb-4 pt-3">
                    <FilterList
                        aggregation={aggregation}
                        query={query[`${aggregation.attribute_code}`]}
                        onChange={onQueryChange}
                        onSeeMore={openBrandFiltering}
                    />
                </div>
            </div>
        );
    },
);

export default FilterAggregationItem;
